import { Injectable } from '@angular/core';
import { NetworkService } from '../../shared/network.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private _networkService: NetworkService) {}

 
  getProfile() {
    return this._networkService.get("api/user/profile",null, null, "bearer");
  }

  editCompany(req: any) {
    return this._networkService.put("api/user", req, null, null);
  }

  uploadImage(image: any) {
    const formData = new FormData();

    formData.append("image", image, 'image.jpg');
    return this._networkService.uploadImages("api/s3upload/image-upload", formData, null, "bearer");
  }
  


}
